module.exports = "<h2>{{statusMessage}}</h2>\n\n<app-login [ngClass]=\"{ hidden: login }\"></app-login>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/user-confirmation/user-confirmation.component.html
// module id = ./src/app/user-confirmation/user-confirmation.component.html
// module chunks = main